import { IconProps } from './index';

const MissedVideoCamera = ({
    title,
    titleId,
    ...props
}: React.SVGProps<SVGSVGElement> & IconProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L19.29 15.79C19.92 16.42 21 15.97 21 15.08V8.91C21 8.02 19.92 7.57 19.29 8.2L17 10.5ZM10.71 14.29C10.32 14.68 9.69 14.68 9.3 14.29L6.12 11.11V13.66H5V9.72C5 9.44 5.22 9.22 5.5 9.22H9.44V10.33H6.89L10 13.43L14.22 9.21L15 10L10.71 14.29Z"
                fill="#ED434B"
            />
        </svg>
    );
};

export default MissedVideoCamera;
